import { privateAxios } from 'services/api/privateAxios';

export const payDebt = () =>
  privateAxios({
    method: 'post',
    url: '/driver/paydebt',
  });
